import { Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { NODE_PARAMS_MAP, NodeType } from '@src/app/models/flow';
import { FlowStore } from '@store/flow-store';

@Component({
    selector: 'app-flow-palette',
    templateUrl: './flow-palette.component.html',
    styleUrl: './flow-palette.component.scss',
    standalone: false,
})
export class FlowPaletteComponent {
    private readonly _store = inject(FlowStore);

    private readonly _allItems = Object.entries(NODE_PARAMS_MAP).map(([key, data]) => ({
        ...data,
        type: key,
    }));

    protected readonly nodes = computed(() => {
        const storeNodes = this._store.nodes();
        const hasIncomingCall = storeNodes.some(n => n.type === NodeType.INCOMING_CALL);

        return this._allItems.map(item => ({
            ...item,
            disabled: item.type === NodeType.INCOMING_CALL && hasIncomingCall,
        }));
    });
}
